export default {
  title: {
    en: `It's not too late! [gift a subscription]`,
  },
}
